import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { AutoEnrollResponse, BenefitSelectionItem } from "src/app/models/benefit";
import { AutoTermCoreBenefit, AutoTermResponse } from "src/app/models/core-benefit";
import { TableColumn } from "src/app/models/table";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-auto-benefit',
    templateUrl: './auto-benefit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AutoBenefitComponent implements OnInit {
    @Input() public autoTermResponse: AutoTermResponse;
    @Input() public autoEnrollResponse: AutoEnrollResponse;
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public autoBenefits = new MatTableDataSource<any>();
    public autoColumns: TableColumn[] = [
		{
			columnName : 'Benefit',
			propertyId   : 'enrollmentName',
            columnType: TableColumnType.label,
		}
	];

    ngOnInit(){
        if (this.autoTermResponse) {
            this.autoColumns.push({
                columnName: 'Termination',
                propertyId: 'terminationDate',
                columnType: TableColumnType.label,
            });
            this.autoBenefits = new MatTableDataSource<AutoTermCoreBenefit>();
            this.autoBenefits.data = this.autoTermResponse.items;
            
        } else if (this.autoEnrollResponse) {
            this.autoBenefits = new MatTableDataSource<BenefitSelectionItem>();
            this.autoBenefits.data = this.autoEnrollResponse.items;
        }
        
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public continueWizard() {
        this.emitComplete.emit();
    }
}